// extracted by mini-css-extract-plugin
export default {"article":"Dragon_article__TOiPY","favorite":"Dragon_favorite__Z+8RJ","carousel":"Dragon_carousel__5bqXK"};